require('../scss/page-product.scss');
require('../fonts/Monly/face.css');
/* ------------------------------------------------------------------------- */

setTimeout(function () {
    $('[data-picture]').removeClass('hide');
}, 10);

// Image Gallery
let image_animation = false;
$(document).on('click', '[data-thumb]', function (e) {
    if (image_animation) return;
    image_animation = true;

    $('[data-thumb]').removeClass('current');
    $(this).addClass('current');

    $('[data-picture]').addClass('hide');

    let bg = 'url(\"'+$(this).data('thumb')+'\")';

    setTimeout(function () {
        $('[data-picture]').css('background-image', bg);
    }, 10);

    setTimeout(function () {
        $('[data-picture]').removeClass('hide');
        image_animation = false;
    }, 20);
});

let cnt = $('[data-hover-zoom]');
let zoom = 2.0;
let oldx=0,oldy=0;
let zoomEnabled=false;
$(document).on('click', '[data-hover-zoom]', function (e) {
    if(zoomEnabled){
        zoom=1.0;
        zoomEnabled=false;
        $('[data-hover-zoom]').css('cursor','zoom-in');
        let x = e.pageX - cnt.offset().left, y = e.pageY - cnt.offset().top;
        let thumb = {
            width: cnt.width()/zoom,
            height: cnt.height()/zoom
        };
        let corner = {
            left: - zoom * Math.min(Math.max(0, x - thumb.width/2), cnt.width() - thumb.width),
            top:  - zoom * Math.min(Math.max(0, y - thumb.height/2), cnt.height() - thumb.height)
        };

        $('.large-version').css(corner).css({
            width: cnt.width() * zoom,
            height: cnt.height() * zoom
        });
        return;
    }else{
        zoom=2.0;
        zoomEnabled=true;
        $('[data-hover-zoom]').css('cursor','zoom-out');
        let x = e.pageX - cnt.offset().left, y = e.pageY - cnt.offset().top;
        let thumb = {
            width: cnt.width()/zoom,
            height: cnt.height()/zoom
        };
        let corner = {
            left: - zoom * Math.min(Math.max(0, x - thumb.width/2), cnt.width() - thumb.width),
            top:  - zoom * Math.min(Math.max(0, y - thumb.height/2), cnt.height() - thumb.height)
        };

        $('.large-version').css(corner).css({
            width: cnt.width() * zoom,
            height: cnt.height() * zoom
        });
        return;
    }
});
$(document).on('mouseleave', '[data-hover-zoom]', function (e) {
    console.log('mouseleave')
    zoom=1.0;
    zoomEnabled=false;
    $('[data-hover-zoom]').css('cursor','zoom-in');

    let x = e.pageX - cnt.offset().left, y = e.pageY - cnt.offset().top;
    let thumb = {
        width: cnt.width()/zoom,
        height: cnt.height()/zoom
    };
    let corner = {
        left: - zoom * Math.min(Math.max(0, x - thumb.width/2), cnt.width() - thumb.width),
        top:  - zoom * Math.min(Math.max(0, y - thumb.height/2), cnt.height() - thumb.height)
    };

    $('.large-version').css(corner).css({
        width: cnt.width() * zoom,
        height: cnt.height() * zoom
    });

    return;
});
$(document).on('mouseenter', '[data-hover-zoom]', function (e) {
    console.log('mouseenter')
    zoom=1.0;
    zoomEnabled=false;
    $('[data-hover-zoom]').css('cursor','zoom-in');

    let x = e.pageX - cnt.offset().left, y = e.pageY - cnt.offset().top;
    let thumb = {
        width: cnt.width()/zoom,
        height: cnt.height()/zoom
    };
    let corner = {
        left: - zoom * Math.min(Math.max(0, x - thumb.width/2), cnt.width() - thumb.width),
        top:  - zoom * Math.min(Math.max(0, y - thumb.height/2), cnt.height() - thumb.height)
    };

    $('.large-version').css(corner).css({
        width: cnt.width() * zoom,
        height: cnt.height() * zoom
    });

    return;
});
$(document).on('mousemove', '[data-hover-zoom]', function (e) {
    if(!zoomEnabled){
        $('[data-hover-zoom]').css('cursor','zoom-in');
        return;
    }

    // if( oldx === 0 ){
    //     oldx = x;
    //     oldy = y;
    //     return;
    // }
    // if(Math.abs(x-oldx)<50 && Math.abs(y-oldy)<50){
    //     // не реагируем на небольшое смещение мышки
    //     return;
    // }
    let x = e.pageX - cnt.offset().left, y = e.pageY - cnt.offset().top;
    let thumb = {
        width: cnt.width()/zoom,
        height: cnt.height()/zoom
    };
    let corner = {
        left: - zoom * Math.min(Math.max(0, x - thumb.width/2), cnt.width() - thumb.width),
        top:  - zoom * Math.min(Math.max(0, y - thumb.height/2), cnt.height() - thumb.height)
    };

    $('.large-version').css(corner).css({
        width: cnt.width() * zoom,
        height: cnt.height() * zoom
    });
});

$(document).on('click', '.blur-it [data-provider-item] a', function (e) {
    e.preventDefault();
    return false;
});

$(document).ready(function (e) {
    $('.available-list').removeClass('blur-it');
});


// Select Size
$(document).on('click', '[data-select-size]:not(.disabled)', function (e) {
    if ($('[data-select-size].active').length == 3) {
        $('[data-select-size].active').removeClass('active');
    }
    $(this).toggleClass('active');
    apply();
});

let apply = function () {
    $('[data-sn]').removeClass('active');
    //$('.available-list').addClass('blur-it');

    let selected = [];
    $('[data-select-size].active').each(function () {
        let s = $(this).data('select-size');
        selected.push(s);
        $('[data-sn="'+s+'"]').addClass('active');
        $('.available-list').removeClass('blur-it')
    });

    $('[data-provider-item]').each(function () {
        let cnt = 0;
        $(this).find('[data-sn].active').each(function () {
            cnt += parseInt($(this).data('count')) || 0;
        });
        if (cnt == 0) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });

    if (selected.length === 0) {
        $('[data-provider-item]').show();
        $('[data-size-current]').html( $('[data-size-current]').data('default'));
    } else {
        $('[data-size-current]').html(selected.join(', '));
    }

};

$(document).on('click', '[data-sizes-append-button]', function (e) {
    $('.drop-down.opened').removeClass('opened');
    apply();
});

// $('.size').click(function (e) {
//     apply();
// });

$(function () {
    let s = location.hash.split('#');
    if (!s[1]) return;
    $('[data-select-size="'+s[1]+'"]:not(.disabled)').addClass('active');
    apply();
});
